module.exports = __webpack_public_path__ + "static/media/Forum.e042c28b.svg";